import React from "react";
import { connect } from "react-redux";
import { updateDesignName } from "../../../../actions/";
import { bindActionCreators } from "redux";

class NameInput extends React.Component {
  onInputChange = (event) => {
    this.props.updateDesignName(event.target.value);
  };

  handleFocus = (event) => {
    event.target.select();
  };

  render() {
    return (
      <div>
        <div className="input-name">
          <input
            type="text"
            value={this.props.designName}
            placeholder="Name Your Design"
            onChange={this.onInputChange}
            onFocus={this.handleFocus}
            maxLength="50"
          />

          <div className="input-name__instructions">
            <em>Name your design.</em>
          </div>
        </div>
        <div className="clear-small"></div>
        <div className="drag-elements__instructions">
          <b>Click + drag elements to move</b>
        </div>
        <div className="clear-small"></div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateDesignName,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(NameInput);
